import { CloseButton } from '~/components/close-button'

export function Layout(props: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className="relative h-full min-h-full overflow-y-hidden bg-[#001721] bg-[linear-gradient(192deg,_#007A6E_0%,_#001721_56%)] text-white">
      {props.children}
      <CloseButton className="fixed right-4 top-[calc(16px+var(--safe-area-top))]" />
    </div>
  )
}
